import logisticsInformation from './logisticsInformation.vue'
export default logisticsInformation
